// We want to use the same minWidth and maxWidth everywhere we display
// product images, because if they all share the same srcSet, browsers
// will be able to re–use images from the cache.
// e.g. if we would specify real minWidth and maxWith on search results
// (both 112px) we would get smaller HTML, but browsers would not re–use
// images from other places (e.g. PDP) they might have in their cache
export const MIN_PRODUCT_IMAGE_SIZE = 54 // gallery thumbnails on PDP
export const MAX_PRODUCT_IMAGE_SIZE = 2000 // zoomed in image on PDP

// We want to use the exact same size attribute for all images of the
// main product on PDP to make sure browsers render just one size
export const PDP_MAIN_IMAGE_SIZES = {
  medium: `calc(50vw - ${2 * 5.34}rem)`,
  base: `calc(100vw - ${2 * 3}rem)`
}
